import { useContext, useMemo } from 'react';
import AppContext from 'app/AppContext';

export const useGetSupportState = () => {
    const { services } = useContext(AppContext);
    const { contactSupportService } = services;

    return useMemo(() => {
        return () => contactSupportService.getSupportState();
    }, [contactSupportService]);
};
